import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  AiOutlineDashboard
} from "react-icons/ai";
import {
  FiUser,
  FiUsers
} from "react-icons/fi";
import { TbTruckDelivery } from "react-icons/tb";
import { MdOutlineWarehouse } from "react-icons/md";
import { RiListOrdered } from "react-icons/ri";
import { VStack } from "@chakra-ui/react";

const Sidebar = ({ onClose }) => {
  const location = useLocation();
  const [isActive, setIsActive] = useState(location.pathname);

  useEffect(() => {
    setIsActive(location.pathname);
  }, [location]);

  const links = [
    { to: "/", icon: <AiOutlineDashboard size={25} />, label: "Dashboard" },
    { to: "/products", icon: <FiUser size={25} />, label: "Products" },
    { to: "/inventory", icon: <FiUser size={25} />, label: "Inventory" },
    { to: "/banks", icon: <FiUser size={25} />, label: "Banks" },
    { to: "/quotation", icon: <FiUser size={25} />, label: "Quotation" },
    { to: "/purchase-order", icon: <FiUser size={25} />, label: "Purchase Order" },
    { to: "/purchase", icon: <FiUser size={25} />, label: "Purchase" },
    { to: "/vendors-list", icon: <FiUser size={25} />, label: "Vendor" },
    { to: "/customer-list", icon: <FiUsers size={25} />, label: "Customer List" },
    { to: "/orders", icon: <RiListOrdered size={25} />, label: "Orders" },
    { to: "/receipt", icon: <RiListOrdered size={25} />, label: "Receipt" },
    { to: "/driver-list", icon: <FiUser size={25} />, label: "Driver" },
    { to: "/vehicle-list", icon: <TbTruckDelivery size={25} />, label: "Vehicle" },
    { to: "/dp-list", icon: <FiUser size={25} />, label: "DP List" },
    { to: "/ledger-reports", icon: <MdOutlineWarehouse size={25} />, label: "Ledger Reports" },
    { to: "/sales-reports", icon: <MdOutlineWarehouse size={25} />, label: "Sales Reports" },
    { to: "/bank-reports", icon: <MdOutlineWarehouse size={25} />, label: "Bank Reports" },
    { to: "/receipt-reports", icon: <MdOutlineWarehouse size={25} />, label: "Receipt Reports" },
    { to: "/purchase-reports", icon: <MdOutlineWarehouse size={25} />, label: "Purchase Reports" }
  ];

  return (
    <VStack align="start" w="full" paddingTop="10px">
      {links.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          onClick={() => {
            if (onClose) onClose();
          }}
          className={`df alc mt10 ph ${
            isActive === link.to
              ? "link activelink-bg link-br"
              : "link unactivelink-bg"
          }`}
        >
          {link.icon}
          {link.label}
        </NavLink>
      ))}
    </VStack>
  );
};

export default Sidebar;
